/**
 * @generated SignedSource<<224acda77734ff4e3484d4a331e73a3e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TeamUpdateMutation$variables = {
  name: string;
  teamId: number;
};
export type TeamUpdateMutation$data = {
  readonly updateTeam: {
    readonly team: {
      readonly account: {
        readonly id: number;
        readonly teams: ReadonlyArray<{
          readonly id: number;
          readonly name: string;
        }>;
      };
      readonly id: number;
      readonly name: string;
    } | null | undefined;
  };
};
export type TeamUpdateMutation = {
  response: TeamUpdateMutation$data;
  variables: TeamUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "teamId"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      }
    ],
    "concreteType": "UpdateTeamResult",
    "kind": "LinkedField",
    "name": "updateTeam",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "teams",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "accounts",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "teams",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamUpdateMutation",
    "selections": (v4/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TeamUpdateMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "3a305820e9ac1615d5d2dd29c83be224",
    "id": null,
    "metadata": {},
    "name": "TeamUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation TeamUpdateMutation(\n  $teamId: Int!\n  $name: String!\n) {\n  updateTeam(id: $teamId, name: $name) {\n    team {\n      id\n      name\n      account {\n        id\n        teams {\n          id\n          name\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c1638d7a38a3e95cd8bd84cda60d5f8b";

export default node;
